function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "firebase_knockout");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "firebase_knockout",
  fill: "currentcolor",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M2.1536599,44.2821283 L8.77417094,1.70081398 C8.87474024,1.05195224 9.37686699,0.540386879 10.0210826,0.430463847 C10.6652981,0.320540814 11.3072962,0.636883208 11.6153312,1.21602447 L18.7334251,14.5763651 L2.1536599,44.2821283 Z M49.1657455,54.6153975 L42.8642953,15.4276097 C42.7691029,14.8647908 42.3694452,14.4023522 41.8282578,14.2288248 C41.2870704,14.0552974 40.694765,14.1996709 40.2928174,14.6030858 L0.546961,54.6153975 L22.5393643,67.0099764 C23.9203776,67.7848885 25.6024118,67.7848885 26.9834251,67.0099764 L49.1657455,54.6153975 Z M31.2945439,20.4167426 L26.2009665,10.6713284 C25.9382828,10.1695323 25.4205475,9.85534145 24.8563533,9.85534145 C24.2921591,9.85534145 23.7744238,10.1695323 23.51174,10.6713284 L1.14709912,50.7523504 L31.2945439,20.4167426 Z",
  id: "icon"
})));

var SvgFirebaseKnockout = function SvgFirebaseKnockout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 50 68",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFirebaseKnockout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/firebase_knockout.15497ba4.svg";
export { ForwardRef as ReactComponent };